import { Identity as IdentityScale } from '@antv/scale';
export const Identity = (options) => {
    return new IdentityScale(options);
};
Identity.props = {};
//# sourceMappingURL=identity.js.map